import React from 'react';
import { observer } from 'mobx-react-lite';
const ExpandedRow = function ExpandedRow(props) {
    const { renderExpandedRows } = props;
    const child = renderExpandedRows(props);
    if (child) {
        return (React.createElement(React.Fragment, null, child));
    }
    return null;
};
ExpandedRow.displayName = 'ExpandedRow';
export default observer(ExpandedRow);
